import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import Img from 'gatsby-image';
import Typography from '@material-ui/core/Typography';
import Tag from '@arcblock/ux/lib/Tag';
import DefaultPostImg from './images/default_post_img.png';
import Link from '../link';
import './style.css';
export default function PostCard(_ref) {
  var post = _ref.post,
      className = _ref.className,
      rest = _objectWithoutPropertiesLoose(_ref, ["post", "className"]);

  var _post$frontmatter = post.frontmatter,
      title = _post$frontmatter.title,
      banner = _post$frontmatter.banner,
      date = _post$frontmatter.date,
      path = _post$frontmatter.path,
      _post$frontmatter$cat = _post$frontmatter.categories,
      categories = _post$frontmatter$cat === void 0 ? [] : _post$frontmatter$cat,
      _post$frontmatter$tag = _post$frontmatter.tags,
      tags = _post$frontmatter$tag === void 0 ? [] : _post$frontmatter$tag;
  var category = categories[0];
  var cleanTags = tags.filter(function (x) {
    return ['arcblock', 'blockchain'].includes(x.toLowerCase()) === false;
  });
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: ("post-card " + className).trim()
  }, rest), !!category && /*#__PURE__*/React.createElement(Tag, {
    className: "post-card__category",
    type: "reverse"
  }, category), /*#__PURE__*/React.createElement(Link, {
    to: path,
    title: title,
    target: "_blank"
  }, banner && banner.childImageSharp && /*#__PURE__*/React.createElement(Img, {
    className: "post-card__cover",
    fluid: banner.childImageSharp.fluid,
    alt: title,
    style: {
      width: '100%',
      height: '191px'
    }
  }), (!banner || !banner.childImageSharp) && /*#__PURE__*/React.createElement("img", {
    src: DefaultPostImg,
    alt: "Post Head Img",
    style: {
      width: '100%',
      height: '191px'
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    component: "div",
    variant: "body1",
    className: "post-card__date"
  }, date), /*#__PURE__*/React.createElement(Typography, {
    component: "h3",
    variant: "body1",
    className: "post-card__title"
  }, title), /*#__PURE__*/React.createElement(Typography, {
    component: "div",
    className: "post-card__tags"
  }, cleanTags.map(function (x) {
    return /*#__PURE__*/React.createElement(Tag, {
      className: "post-card__tag",
      key: x
    }, x);
  }))));
}
PostCard.defaultProps = {
  className: ''
};